import { httpClient } from "../http-client";
import { PlayerConsentsPersonalisationResponse } from "../models/player-contact-models";
import { PlayerContactRequest } from "../models/player-login-request";
import { clientId } from "@/account/use-user-account";

export namespace PlayerContactApi {
    export async function callPlayerContact(contactRequestData: PlayerContactRequest) {
        const response = await httpClient.post<string>("/kasa/player/login", contactRequestData);

        return response.data;
    }

    export async function getContestPersonalisation(): Promise<boolean> {
        if (!clientId.value) return false;

        const response = await httpClient.get<PlayerConsentsPersonalisationResponse>(
            "/kasa/player/consents/personalisation"
        );

        return response.data.granted;
    }
}
